import type { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
import { hasValue } from '@r-and-a-shared-ui/utils';
import {
  getCtaHrefValue,
  getFirstMappedLinkedItemOrDefault,
  getMappedLinkedItems,
} from './utils/component-mapping-helpers';
import {
  getFirstLinkedItemOrDefault,
  getMappedTaxonomies,
  getSingleChoiceValue,
} from '@r-and-a-shared-ui/common-kontent-client/utils';

export const player_portals_form = (data: PLAYER_PORTALS_MODELS.Form) => {
  if (!hasValue(data?.elements)) {
    return undefined;
  }

  const { elements } = data;

  return {
    formCodename: data.system.codename,
    formHeaderData: getFirstMappedLinkedItemOrDefault(elements?.form_header),
    steps: getMappedLinkedItems(elements?.form_content),
    formFooterData: getFirstMappedLinkedItemOrDefault(elements?.form_footer),
    errorsDictionary: getMappedLinkedItems(elements?.errors_messages),
    successMessagesDictionary: getMappedLinkedItems(elements?.success_messages),
    nextStepsAfterSubmit: getMappedLinkedItems(elements?.next_steps),
    defaultValuesCallbackUrl: getCtaHrefValue(
      getFirstLinkedItemOrDefault(elements?.default_values_callback_url),
    ),
    defaultValuesJson: elements?.default_values_json?.value,
    defaultValuesEntity: getMappedTaxonomies(elements?.default_values_entity),
    formType: getSingleChoiceValue(elements?.form_type) ?? 'classic',
    customClassname: elements?.custom_classname?.value,
  };
};

export default player_portals_form;
